const $onReady = require('public/js/lib/on-ready');

const getPaypalButtonHandler = () =>
	import(/* webpackChunkName: "paypal-button-handler" */ 'public/js/components/paypal-button-handler');

const pageHasPaypalShellChrome = () =>
	rp$('.cart-listing').length > 0 || rp$('.paypal-smart-flyout-button').length > 0;

const handlePaypalButtonHandler = () => {
	if (!pageHasPaypalShellChrome()) {
		return;
	}
	getPaypalButtonHandler()
		.then((module) => {
			module.default.initPaypalButtons();
		})
		.catch((error) => {
			rp_app.logger.error({
				message: 'Failed to load PayPal button handler',
				error: error,
				listener: 'get-paypal-button-handler',
			});
		});
};

$onReady({
	rp$,
	window: globalThis,
	label: 'get-paypal-button-handler',
	fn: handlePaypalButtonHandler,
});
